module.exports = {
        srcSet: __webpack_public_path__ + "assets/images/crash-page-ce8349d6f8bbb312.png"+" 374w",
        images: [{path: __webpack_public_path__ + "assets/images/crash-page-ce8349d6f8bbb312.png",width: 374,height: 250}],
        src: __webpack_public_path__ + "assets/images/crash-page-ce8349d6f8bbb312.png",
        toString: function(){return __webpack_public_path__ + "assets/images/crash-page-ce8349d6f8bbb312.png"},
        
        width: 374,
        height: 250
      }